<div class="content nopad dark">
	<div class="row">
		<div class="col-lg-12">
			<div class="flightmap-container">
				<div id="flightmap" [ngClass]="'speed-' + viewer?.speed"></div>
				<div *ngIf="loading || error" class="flightmap-overlay">
					<div *ngIf="loading">
						<div class="logo-spin" [class.light]="light"></div>
						Loading...
					</div>
					<div *ngIf="error">
						<div class="logo-spin stopped" [class.light]="light"></div>
						{{error}}
					</div>
				</div>
			</div>
		</div>
	</div>
	<div [hidden]="error" class="row">
		<div class="col-lg-12">
			<app-dvs-chart #scrubberChart [options]="scrubberOptions" [height]="'150px'" [timezone]="fleet ? fleet.time_offset_hours : 0" [short]="true"></app-dvs-chart>
		</div>
	</div>

	<div class="content">
		<div class="row">
			<div *ngIf="pathFrame && pathFrame.ts" class="col-lg-6">
				<div class="flat-indicator">
					<span class="label">Timestamp:</span> {{ (pathFrame.ts * 1000) | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}
				</div>
			</div>
			<div *ngIf="pathFrame && pathFrame.regime_id" class="col-lg-6">
				<div class="flat-indicator">
					<span class="label">Regime:</span> {{ lookupRegime(pathFrame.regime_id) }}
				</div>
			</div>
		</div>
		<div class="row">
			<app-indicator-number [frame]="pathFrame" field="indicated airspeed" label="Indicated Airspeed" units="kts"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="heading" label="Heading" units="deg"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="altitude" label="Altitude" units="ft"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="altitude rate" label="Altitude Rate" units="ft/min"></app-indicator-number>
		</div>
		<div class="row">
			<app-indicator-number [frame]="pathFrame" field="ng" label="NG" units="% rpm"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="l/h eng ng" label="L/H Eng NG" units="% rpm"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="r/h eng ng" label="R/H Eng NG" units="% rpm"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="nr" label="NR" units="% rpm"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="torque" label="Torque" units="%"></app-indicator-number>
			<app-indicator-number [frame]="pathFrame" field="xmsn torque" label="XMSN Torque" units="%"></app-indicator-number>
		</div>
	</div>
</div>